// src/pages/ChatPage.js
import React, { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { apiRequest } from "../services/api";

function ChatPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { lang } = useContext(LanguageContext);

  const [messages, setMessages] = useState([]);
  const [threadId, setThreadId] = useState(null);
  const [text, setText] = useState("");

  const bottomRef = useRef(null);
  
  const [showWhatsappCTA, setShowWhatsappCTA] = useState(true);

const whatsappMessage =
  lang === "EN" ? "I need help" : "أحتاج مساعدة";

const whatsappLink = `https://wa.me/96179338100?text=${encodeURIComponent(
  whatsappMessage
)}`;

  const TEXT = {
    EN: {
      title: "Support Chat",
      placeholder: "Type your message…",
      send: "Send",
    },
    AR: {
      title: "محادثة الدعم",
      placeholder: "اكتبي رسالتك…",
      send: "إرسال",
    },
  }[lang];

  /* Load thread */
  useEffect(() => {
  let interval;

  async function load() {
    let list;
try {
  list = await apiRequest("/contact-messages/mine");
} catch (e) {
  navigate(-1);
  return;
}


    const targetId =
      location.state?.messageId || list?.[0]?.id;

    if (!targetId) return;

    setThreadId(targetId);

    const thread = list.find((m) => m.id === targetId);
    if (thread) {
      setMessages(thread.replies || []);
    }

    await apiRequest(`/contact-messages/${targetId}/read`, {
      method: "POST",
    });

    // 🔁 start polling
    interval = setInterval(async () => {
      const fresh = await apiRequest("/contact-messages/mine");
      const updated = fresh.find((m) => m.id === targetId);
      if (updated) {
        setMessages(updated.replies || []);
      }
    }, 4000); // every 4 seconds
  }

  load();

  return () => clearInterval(interval);
}, []);

useEffect(() => {
  if (!localStorage.getItem("esill-token")) {
    navigate(-1);
  }
}, []);

  /* Auto scroll */
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  /* Send message */
  const send = async () => {
  if (!text.trim()) return;
  if (!threadId) return; // ✅ PREVENT null message_id

  await apiRequest(`/contact-messages/${threadId}/user-reply`, {
    method: "POST",
    body: JSON.stringify({ body: text }),
  });

  setMessages((m) => [
    ...m,
    { sender_type: "user", body: text },
  ]);

  setText("");
};





  return (
    <div
      className="w-full min-h-screen bg-[#F7F3F1] flex flex-col"
      dir={lang === "AR" ? "rtl" : "ltr"}
    >
      {/* HEADER */}
      <div className="fixed top-0 left-0 w-full bg-white border-b border-[#E6D8D2] px-4 py-4 flex items-center gap-3 z-50">
        <button
          onClick={() => navigate(-1)}
          className="text-2xl opacity-70"
        >
          ×
        </button>
        <h1 className="text-sm font-semibold">{TEXT.title}</h1>
      </div>

      {/* CHAT */}
      <div className="flex-1 pt-20 px-4 pb-28 space-y-3 overflow-y-auto">
        {messages.map((m, i) => (
          <div
            key={i}
            className={`flex ${
              m.sender_type === "user"
                ? "justify-end"
                : "justify-start"
            }`}
          >
            <div
              className={`max-w-[75%] text-sm px-3 py-2 rounded-2xl ${
                m.sender_type === "user"
                  ? "bg-black text-white rounded-br-sm"
                  : "bg-white shadow-sm rounded-bl-sm"
              }`}
            >
              {m.body}
            </div>
          </div>
        ))}
        <div ref={bottomRef} />
      </div>

      {/* INPUT */}
      <div className="fixed bottom-0 left-0 w-full bg-white border-t border-[#E6D8D2] px-3 py-3 flex gap-2">
        <input
  value={text}
  onChange={(e) => setText(e.target.value)}
  placeholder={TEXT.placeholder}
  disabled={!threadId}
  className="flex-1 border border-[#E6D8D2] rounded-full px-4 py-2 text-sm disabled:opacity-50"
/>
<button
  onClick={send}
  disabled={!threadId}
  className="px-5 py-2 bg-black text-white rounded-full text-sm font-semibold disabled:opacity-50"
>
  {TEXT.send}
</button>
      </div>
      {showWhatsappCTA && (
  <div
    className="fixed z-[9999] bottom-20 right-5 flex flex-col items-center gap-2"
    dir="ltr"
  >
    {/* Close button */}
    <button
      onClick={() => setShowWhatsappCTA(false)}
      className="
        w-7 h-7 rounded-full
        bg-white border border-[#E6D8D2]
        flex items-center justify-center
        text-black text-sm
        shadow-md opacity-90
      "
      aria-label="Close WhatsApp"
    >
      ×
    </button>

    {/* WhatsApp button */}
    <a
      href={whatsappLink}
      target="_blank"
      rel="noreferrer"
      className="
        w-14 h-14 rounded-full
        flex items-center justify-center
        shadow-lg
        active:scale-95 transition
      "
      style={{ backgroundColor: "#25D366" }}
      aria-label="WhatsApp"
    >
      <img
        src="/icons/whatsapp.png"
        alt="WhatsApp"
        className="w-7 h-7"
      />
    </a>
  </div>
)}

    </div>
  );
}

export default ChatPage;
